module.exports = __webpack_public_path__ + "static/media/ifta.610ea44f.svg";